<script setup lang="ts">
// Import the toast component explicitly
import Toast from '~/components/ds/Toast.vue'

// Set <html lang> from the active locale. It was missing entirely (Lighthouse
// a11y + i18n flag), which hurts screen readers and Google language detection.
// Uses the BCP-47 `language` from the i18n config (es-ES, en-US, …).
const { locale, locales } = useI18n()
const htmlLang = computed(() => {
  const match = (locales.value as Array<{ code: string, language?: string }>)
    .find(l => l.code === locale.value)
  return match?.language || locale.value
})
useHead({ htmlAttrs: { lang: htmlLang } })
</script>

<template>
  <div class="min-h-screen bg-white dark:bg-gray-950">
    <UApp>
      <NuxtRouteAnnouncer />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
      <Toast />
      <CookieBanner />
    </UApp>
  </div>
</template>
